module.exports = __webpack_public_path__ + "img/image-about-us-01-academy-template-p-500.3e860dfd.jpeg";